import TranslateIcon from '@mui/icons-material/Translate';
import { Box } from '@mui/material';
import { getUiLanguage, setUiLanguage } from '../lib/i18n';
import { Button } from './button';

/**
 * Interface language switch — the same everywhere in FormTags (platform, company app, public form,
 * share page): the translate icon + the OTHER language's name; one click switches and reloads.
 */
/** `compact`: in tight top bars the name hides on phones (icon only). */
export function LanguageButton({ compact = false }: { labeled?: boolean; compact?: boolean } = {}) {
  const language = getUiLanguage();
  const next = language === 'ar' ? 'en' : 'ar';
  return (
    <Button
      variant="text"
      startIcon={<TranslateIcon />}
      onClick={() => {
        setUiLanguage(next);
        window.location.reload();
      }}
      lang={next}
      aria-label={next === 'en' ? 'English' : 'العربية'}
      sx={{
        borderRadius: 999,
        px: 1.75,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ...(compact && { minWidth: { xs: 40, sm: 64 }, px: { xs: 1, sm: 1.75 }, '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } } }),
      }}
    >
      <Box component="span" sx={compact ? { display: { xs: 'none', sm: 'inline' } } : undefined}>
        {next === 'en' ? 'English' : 'العربية'}
      </Box>
    </Button>
  );
}
